import { render, staticRenderFns } from "./minerals.vue?vue&type=template&id=c47ab31e&scoped=true&"
import script from "./minerals.vue?vue&type=script&lang=js&"
export * from "./minerals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c47ab31e",
  null
  
)

export default component.exports